import { MapPin, MessageCircle, Globe } from "lucide-react";
import { useLang, WA_LINK } from "../i18n";
import { Chapter, Reveal } from "./Reveal";

export function Contact() {
  const { t } = useLang();
  const cards = [
    {
      icon: MapPin,
      label: t.contact.office,
      lines: t.contact.address,
      href: "https://maps.google.com/?q=220+N+Hargrave+St,+Banning,+CA+92220",
      testId: "contact-address",
    },
    {
      icon: MessageCircle,
      label: t.contact.wa,
      lines: [t.contact.waNumber],
      href: WA_LINK,
      cta: t.contact.waCta,
      testId: "contact-whatsapp",
    },
    {
      icon: Globe,
      label: t.contact.web,
      lines: [t.contact.webValue],
      href: "https://mineralsmx.com",
      testId: "contact-website",
    },
  ];
  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 md:py-32 bg-[#151B24]/35">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Chapter kicker={t.contact.kicker} title={t.contact.title} testId="contact" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.testId} delay={i * 0.1}>
                <a
                  data-testid={c.testId}
                  href={c.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group glass flex h-full flex-col p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_16px_50px_rgba(201,162,39,0.12)]"
                  style={{ borderRadius: "4px 24px 4px 24px" }}
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#C9A227]/30 bg-[#C9A227]/10 text-[#C9A227] group-hover:bg-[#C9A227] group-hover:text-[#07111F] transition-[background-color,color] duration-400">
                    <Icon size={22} />
                  </div>
                  <p className="mt-5 text-xs uppercase tracking-[0.3em] text-[#EDF1F6]/70">{c.label}</p>
                  {c.lines.map((l, j) => (
                    <p key={j} className={`${j === 0 ? "mt-2" : ""} font-body text-base text-[#F5F7FA]`}>{l}</p>
                  ))}
                  {c.cta && (
                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#C9A227] group-hover:text-[#F5F7FA] transition-colors duration-300">
                      <MessageCircle size={15} /> {c.cta}
                    </span>
                  )}
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
